export default __webpack_public_path__ + "static/inventory-optimisation-1-b11cd01cb4a4191583489aaef8a1a60c.png";